import React, { FC, useEffect, useState } from 'react'
import { useLocale } from '../../contexts/localeContext';
import { TranslationKeys } from '../../contexts/TranslationKeys';
import { ListQuery } from '../../models/ListQuery';
import { Name } from '../../models/Name';
import { PaginationModel } from '../../models/Pagination';
import ActivityFrame from '../activity-frame/activity-frame';
import EmptyTableState from '../emptyTableState/EmptyTableState';
import List from '../list/list';

interface Props {
    dataMethod: (listParameters?: ListQuery) => Promise<{ rows: Name[], pagination: PaginationModel }>;
    setSelectedDevice: (device: Name) => void;
    onNext: (event: any) => void;
    onBack: (event: any) => void;
    listParameters?: ListQuery;
}

const SelectDeviceForm: FC<Props> = ({ dataMethod, setSelectedDevice, onNext, onBack, listParameters }) => {
    const [devices, setDevices] = useState<Name[]>([])
    const [task, setTask] = useState('');
    const [taskSelected, setTaskSelected] = useState(false);
    const { translate } = useLocale();
    const [busy, setBusy] = useState(false);

    const itemSelected = (item: any) => {
        const selectedItem = item.props['data-item'];
        if (selectedItem) {
            setTaskSelected(true);
            setTask(selectedItem.value);
            setSelectedDevice({ label: selectedItem.label, value: selectedItem.value });
            onNext({task: selectedItem.value, description: selectedItem.label});
        }
    }

    const getListItems = (): { value: JSX.Element; isSelected: boolean; }[] => {
        return devices.map(item => {
            return {
                value: (
                    <div className="flex flex-row items-center cursor-pointer select-none" data-item={item}>
                        <div className="p-2">{item.label}</div>
                    </div>
                ),
                isSelected: item.value === task
            };
        })
    }

    useEffect(() => {
        setBusy(true);
        dataMethod(listParameters).then((response) => {
            setDevices(response.rows);
        }).catch(() => {
            setDevices([]);
        }).finally(() => {
            setBusy(false);
        })
    }, [listParameters])

    return <div className="pt-3 pr-3 h-full relative">
        <ActivityFrame busy={busy} busyMessage={translate.byKey(TranslationKeys.loadingDevices)} className={`flex ${busy ? 'h-full w-full justify-center' : ''} flex-wrap content-center`}>
            <div className='w-full flex flex-col'>
                {devices.length > 0 ?
                    <List onSelect={(_, item) => itemSelected(item)} isStriped items={getListItems()} />
                    : <EmptyTableState message={translate.byKey(TranslationKeys.noEnrolmentDeviceFound)} hideAddNewButton={true} />
                }
            </div>

            <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
                <div className="flex flex-row mt-4">
                    <button
                        className="py-1 px-5 secondary secondary-inverse"
                        type="button" onClick={onBack} >{translate.byKey(TranslationKeys.back)}</button>
                </div>
                {devices.length > 0 ?
                    <div className="flex flex-row justify-end mt-4 pl-3">
                        <button
                            className={`py-1 px-5 secondary ${taskSelected ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed'}`}
                            type="button"
                            onClick={onNext}>{translate.byKey(TranslationKeys.next)}</button>
                    </div> : null}
            </div>
        </ActivityFrame>
    </div>
}

export default SelectDeviceForm;
